import SOCDashboard from './soc_dashboard_new';

function App() {
  return <SOCDashboard />;
}

export default App;